module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_vm._t("ribbon"), _vm._v(" "), _c('div', {
    staticClass: "ribbon-content"
  }, [_vm._t("default", [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-147d2d50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ribbon/ribbon-panel.vue
// module id = 668
// module chunks = 85